import React from 'react'
import { useTranslation } from 'react-i18next'
import { CircularProgress, Button } from '@mui/material'

interface GenerateVariationsSectionProps {
  paraPhrasesLoading: boolean
  intent: any
  activeTab: string
  userSaysTarget: any
  generateVariations: boolean
  onGenerateWithIntent: () => void
  onGenerateWithoutIntent: () => void
}

const GenerateVariationsSection: React.FC<GenerateVariationsSectionProps> = ({
  paraPhrasesLoading,
  intent,
  activeTab,
  userSaysTarget,
  generateVariations,
  onGenerateWithIntent,
  onGenerateWithoutIntent,
}) => {
  const { t } = useTranslation('translation')

  const showWithIntent =
    intent &&
    intent._id &&
    !paraPhrasesLoading &&
    !intent.is_paraphrased &&
    activeTab === 'usersays'

  const showWithoutIntent =
    generateVariations &&
    intent &&
    !intent._id &&
    !paraPhrasesLoading &&
    !intent.is_paraphrased &&
    activeTab === 'usersays'

  const isWithoutIntentDisabled =
    paraPhrasesLoading ||
    (!userSaysTarget && intent && !intent.questions) ||
    (userSaysTarget?.text?.trim().length === 0 && intent && !intent.questions)

  return (
    <>
      {paraPhrasesLoading && (
        <CircularProgress size={20} sx={{ mr: 1, color: 'primary.main' }} />
      )}

      {paraPhrasesLoading && (
        <div className="mr-auto font-16">
          {t('Generating training phrases...  ')}
        </div>
      )}

      {showWithIntent && (
        <div className="mr-auto font-16">
          {t('Looking to expand your question set?  ')}
          <Button
            variant="text"
            color="primary"
            disabled={paraPhrasesLoading}
            onClick={onGenerateWithIntent}
            sx={{ py: 0, textTransform: 'none' }}
          >
            {t('Generate Variations')}
          </Button>
        </div>
      )}

      {showWithoutIntent && (
        <div className="mr-auto font-16">
          {t('Looking to expand your question set?  ')}
          <Button
            variant="text"
            color="primary"
            disabled={isWithoutIntentDisabled}
            onClick={onGenerateWithoutIntent}
            sx={{ py: 0, textTransform: 'none' }}
          >
            {t('Generate Variations')}
          </Button>
        </div>
      )}
    </>
  )
}

export default GenerateVariationsSection
